export default __webpack_public_path__ + "static/media/atmcard.30d2cf5e.png";